import { oc } from '@orpc/contract';
import { deleteKpiInputSchema, deleteKpiOutputSchema } from '../schemas/kpis.schemas.js';
export const deleteKpiContract = oc
    .route({
    method: 'DELETE',
    path: '/kpis/{id}',
    tags: ['KPIs'],
    summary: 'Permanently delete a KPI with no history, dependents, target links or sub-KPIs; 409 with structured blockers otherwise (ADMIN, PM)',
})
    .input(deleteKpiInputSchema)
    .output(deleteKpiOutputSchema);
//# sourceMappingURL=delete-kpi.contract.js.map